module.exports = __webpack_public_path__ + "img/icon_dynamed.70210775.png";